import { Component } from '@angular/core';
import { AppService } from 'app/app.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';

@Component({
	selector: 'modal-help-formula',
	templateUrl: './modal-help-formula.component.html'
})
export class ModalHelpFormulaComponent extends UIModalBaseComponent {

	helpTabs = [
		{ id: 'variables', description: 'Variables' },
		{ id: 'operators', description: 'Operators' },
		{ id: 'advanced', description: 'Advanced' }
	];
	helpTab = 'variables';

	// Scoped variable prefixes. Only one scope is listed at a time to keep the table readable.
	scopes = [
		{ id: 'System', description: 'System' },
		{ id: 'Subsystem', description: 'Subsystem' },
		{ id: 'AreaGroup', description: 'Area group' },
		{ id: 'Area', description: 'Area' }
	];
	scope = 'System';
	scopedVariables: { name: string; description: string }[] = [];

	// When provided (via open({ variables: [...] })), the Variables tab shows this
	// context-specific list instead of the default quote variables.
	variables: { name: string; description: string }[] = null;

	// Set via open({ factors: true }) by the product and quote line factor editors. Those are the
	// only places the line specific and scoped variables resolve, so they stay hidden elsewhere.
	factors = false;

	constructor(
		public app: AppService
	) {
		super();
	}

	open(data?: any) {
		this.variables = (data && data.variables) ? data.variables : null;
		this.factors = !!(data && data.factors);
		this.helpTab = 'variables';
		this.selectScope(this.scopes[0].id);
		this.modal.open();
	}

	selectScope(id: string) {
		const scope = this.scopes.find(item => item.id === id) || this.scopes[0];
		const vat = this.app.translatedVATTerm || 'tax';
		const s = scope.description.toLowerCase();

		this.scope = scope.id;
		this.scopedVariables = [
			{ name: scope.id + 'ProductNet', description: `The ex ${vat} subtotal of all products in the line's ${s} (without labour).` },
			{ name: scope.id + 'ProductCost', description: `The ex ${vat} subtotal of all product costs in the line's ${s} (without labour).` },
			{ name: scope.id + 'ProductVat', description: `The total ${vat} amount of all products in the line's ${s} (without labour).` },
			{ name: scope.id + 'ProductTotal', description: `The inc ${vat} total of all products in the line's ${s} (without labour).` },
			{ name: scope.id + 'LabourHours', description: `The total number of labour hours in the line's ${s}.` },
			{ name: scope.id + 'LabourNet', description: `The ex ${vat} subtotal of all labour in the line's ${s}.` },
			{ name: scope.id + 'LabourCost', description: `The ex ${vat} subtotal of all labour costs in the line's ${s}.` },
			{ name: scope.id + 'LabourVat', description: `The total ${vat} amount of all labour in the line's ${s}.` },
			{ name: scope.id + 'LabourTotal', description: `The inc ${vat} total of all labour in the line's ${s}.` },
			{ name: scope.id + 'Net', description: `The ex ${vat} subtotal of all products and labour in the line's ${s}.` },
			{ name: scope.id + 'Cost', description: `The ex ${vat} subtotal of all product and labour costs in the line's ${s}.` },
			{ name: scope.id + 'Vat', description: `The total ${vat} amount of all products and labour in the line's ${s}.` },
			{ name: scope.id + 'Total', description: `The inc ${vat} total of all products and labour in the line's ${s}.` }
		];
	}

}
